import { useCallback, useEffect, useState } from 'react';
import { GetReminderMessagesUrl, ImageLocation } from 'src/utils/URLUtils';
import { store } from '../../store/store';
import useFetch from '../api/useFetch';

export const useReminder = () => {
    const [messages, setMessages] = useState<string[]>([]);
    const { send, isLoading } = useFetch<string[]>();

    useEffect(() => {
        const fetchMessages = async () => {
            const { response } = await send(GetReminderMessagesUrl());
            if (response) {
                setMessages(response);
            }
        };

        fetchMessages();
    }, [send]);

    const getRandomMessage = useCallback((): string => {
        if (messages.length === 0) {
            return 'Keep learning and growing!';
        }
        const randomIndex = Math.floor(Math.random() * messages.length);
        return messages[randomIndex];
    }, [messages]);

    const showReminderNotification = useCallback(() => {
        const state = store.getState();
        const learningInfo = state.learning.learningInfo;

        if (!learningInfo?.ReviewWordIds) return;

        const toReviewCount = learningInfo.ReviewWordIds.length;
        const displayCount = toReviewCount > 200 ? '200+' : toReviewCount;

        const message = `${getRandomMessage()} You have ${displayCount} words for today.`;

        // Request notification permission if not already granted
        if (Notification.permission === 'default') {
            Notification.requestPermission();
        }
        // Show notification if permission is granted
        if (Notification.permission === 'granted') {
            new Notification('Word Review Reminder', {
                body: message,
                icon: ImageLocation('Tiles/StoreLogo.scale-200.png')
            });
        }
    }, [getRandomMessage]);

    return {
        getRandomMessage,
        showReminderNotification,
        isLoading
    };
};
